import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'postType'
})
export class PostTypePipe implements PipeTransform {

  transform(menu: string): string {
    switch(menu.toUpperCase()) {
      case 'RESTAURANTS':
        return 'Post your Restaurant';
      case 'NIGHTCLUBS':
        return 'Post your Nightclub';
      case 'VIDEOS':
        return 'Post your Videos';
      case 'PHOTOS':
        return 'Post your Photos';
      case 'BARS':
        return 'Post your Bar';
      case 'CONCERTS & SHOWS':
        return 'Post your Concerts & Shows';
      case 'MOVIES':
        return 'Post your Movie News & Videos';
      case 'NEWS':
        return 'Post your News';
      case 'FASHION NEWS':
        return 'Post your Fashion Store, Event or Photos';
      case 'TRANSPORTATION':
        return 'Post your Car or Transportation Service';
      case 'HOTELS & RESORTS':
        return 'Post your Hotel & Resort';
      case 'PARTIES & EVENTS':
        return 'Post your Event';
      case 'MUSIC':
        return 'Post your Music News & Videos';
      case 'ALL':
        return 'Post your Business or Event';
      default:
        return null;
    }
  }
}
